import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DropdownService } from 'src/app/services/dropdown.service';
import { HomeBase } from '../../models/home-base';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-jumper',
  templateUrl: './jumper.component.html',
  styleUrls: ['./jumper.component.scss']
})
export class JumperComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;

  constructor(private dropdownService: DropdownService, private route: ActivatedRoute) {}

  readonly jumpersDisplay = (jumper: any): string =>
    jumper ? `${jumper.firstName} ${jumper.lastName}` : '';

  userInfo = JSON.parse(sessionStorage.getItem('userInfo'));

  homeBases$: Observable<any> = this.dropdownService.getMadbHomeBases();
  homeBasesDropdownList: any = [];
  homebaseDropdownSubscription: Subscription;
  selectedBase: HomeBase;
  jumpers$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  jumpers = [];
  filteredJumpers$: Observable<any[]>;
  filteredAircafts$: Observable<any[]>;
  jumperCtrl = new FormControl();
  selectedJumper: any;
  jumperSubscription: Subscription;
  jumpersSubscription: Subscription;
  formSubscription: Subscription;
  baseChangeJumpersSubscription: Subscription;
  dropdownSubscription: Subscription;
  baseChangeSubscription: Subscription;
  jumperBaseSubscription: Subscription;
  
  ngOnInit(): void {
    this.homebaseDropdownSubscription = this.homeBases$.subscribe((bases) => {
      this.homeBasesDropdownList = [{ text: '', value: null, id: null}, ...bases]
    });

    this.jumperBaseSubscription = this.form.get('jumperBaseId').valueChanges.subscribe((baseId) => {
      if (baseId === 0 || baseId === null) {
        this.form.get('jumperDetails').disable();
      } else {
        this.form.get('jumperDetails').enable();
      }
    });

    this.filteredJumpers$ = this.form.get('jumperDetails').valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );

    this.formSubscription = this.form.get('jumperDetails').valueChanges.subscribe((jumper) => {
      if (jumper) {
        this.form.get('jumperBaseId').patchValue(jumper.baseId, { emitEvent: false });
        this.dropdownService.getBaseById(jumper.baseId).subscribe((base) => {
          base.text = base.name;
          base.value = jumper.baseId;
          base.code = base.value;
          base.baseCode = base.affiliated;
          base.baseId = base.id;
          this.form.get('jumperBaseDetails').patchValue(base);
        });
      }
    });

    // here we check if we are in edit mode, then we get the jumper list in case the user wants to change the jumper, but doesn't change the home base which usually triggers the jumper list
    if(this.route.snapshot.params.id) {
      this.form.get('jumperBaseId').valueChanges.subscribe((baseId) => {
        if(!this.jumpers.length && (this.form.get('jumperBaseId').value !== null)) {
          this.jumpersSubscription = this.dropdownService
          .getJumpers(this.form.get('jumperBaseId').value)
          .pipe(map((response) => response.value))
          .subscribe((jumpers) => {
            const activeJumpers = jumpers.filter((jumper) => jumper.activeStatus === true);
            this.jumpers = activeJumpers;
            this.filteredJumpers$ = this.form.get('jumperDetails').valueChanges.pipe(
              startWith(''),
              map((value) => this._filter(value || ''))
              );
          });
        }
      })
    }


  }
    
  
  onBaseChange(event: any) {
    this.jumpers$.next([]);
    this.jumperCtrl.patchValue(null);
    this.form.get('personnelId').patchValue(0);
    this.baseChangeSubscription = this.homeBases$.subscribe((bases) => {
      const base = bases.find((base) => event.value === base.id);
      this.form.get('jumperBaseDetails')?.patchValue(base);
      this.form.get('jumperBaseId').patchValue(this.selectedBase.id);

    })
      this.selectedBase = this.homeBasesDropdownList.find((base) => event.value === base.id);
      this.form.get('jumperBaseDetails')?.patchValue(this.selectedBase);

      this.form.get('jumperDetails')?.patchValue(null);
      this.form.get('personnelId').patchValue(0);
      if (this.selectedBase.id === null) {
        this.form.get('jumperDetails')?.patchValue(null);
        this.form.get('personnelId').patchValue(0);
        this.form.get('jumperDetails').disable();
        return;
      }
      this.baseChangeJumpersSubscription = this.dropdownService
        .getJumpers(this.selectedBase.baseId)
        .pipe(map((response) => response.value))
        .subscribe((jumpers) => {
          const activeJumpers = jumpers.filter((jumper) => jumper.activeStatus === true);
          this.jumpers$.next(activeJumpers);
          this.jumpers = activeJumpers;
          this.filteredJumpers$ = this.form.get('jumperDetails').valueChanges.pipe(
            startWith(''),
            map((value) => this._filter(value || ''))
          );
        });
  }
    
  onJumperSelection(selectedJumper: any) {
    this.form.get('personnelId').patchValue(selectedJumper.id);
    this.dropdownSubscription = this.dropdownService.getJumperById(selectedJumper.id, this.form.get('malfunctionDate').value).subscribe((jumper: any) => {
      this.form.get('jumperDetails').patchValue(jumper);
    });
  }
    
  private _filter(value: any): string[] {
    const filterValue = value?.toString().toLowerCase();
    
    return this.jumpers.filter(
      (jumper: any) =>
      jumper?.firstName.toLowerCase().includes(filterValue) ||
      jumper?.lastName.toLowerCase().includes(filterValue)
      );
  }

  // TODO: These unsubscribes are not working as expected. We have a data leak here.
    ngOnDestroy(): void {
      this.jumpers$?.complete();
      this.jumperSubscription?.unsubscribe();
      this.formSubscription?.unsubscribe();
      this.baseChangeJumpersSubscription?.unsubscribe();
      this.jumpersSubscription?.unsubscribe();
      this.dropdownSubscription?.unsubscribe();
      this.baseChangeSubscription?.unsubscribe();
      this.jumperBaseSubscription?.unsubscribe();
      this.homebaseDropdownSubscription?.unsubscribe();
    }
  }
    